import HeaderMobile from "./headerMobile";
import AsideMenu from "./asideMenu";
import React, {useState} from "react";
import styled from "styled-components";

export default function Layout({children}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return <AppContainer>
    <HeaderMobile />
    <ContentWrapper>
      <AsideMenu isOpen={isMenuOpen} toggleMenu={toggleMenu} />
      <MainContent $isOpen={isMenuOpen}>
        {children}
      </MainContent>
    </ContentWrapper>
  </AppContainer>
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const MainContent = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: #f4f5f7;
  margin-top: var(--header-height);
  margin-right: 2rem;
  padding: 2rem;
  border-radius: 40px;
  margin-left: ${(props) => (props.$isOpen ? "23rem" : "9rem")};
  transition: margin-left 0.3s ease;

  @media (max-width: 768px) {
      margin-left: 0;
      margin-right: 0;
      border-radius: 0;
      padding: 0;
  }
`;
